export default __webpack_public_path__ + "static/when-words-meet-machines-header-89bb6ff047b7c3f6ab7522c8b169ffbf312ad3c9df02ea141f3932b3ebe3d8ec.png";